module.exports = __webpack_public_path__ + "img/linkedin.6de47ce7.svg";